import { applicationResidenceApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const RESIDENCE_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/residences`,
  {
    GET_RESIDENCES: 'GET_RESIDENCES',
  },
);

const residencesSchema = new schema.Entity('data', {}, { idAttribute: 'residenceId' });

export const getResidencesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationResidenceApi.getResidences(params);

  return dispatch({
    type: RESIDENCE_ACTION_TYPE.GET_RESIDENCES,
    payload: normalize(data, [residencesSchema]).entities.data,
  });
});
